import { getServiceUri, GraphQLServices } from "@rambody/commons/lib/services";
import { Language } from "../models/Language";
import { LanguageCodes } from "./enums";

function getBaseUrl(): string {
  return (
    (window as Window & typeof globalThis & { servicesEndpoint: string })
      .servicesEndpoint || "http://localhost:7071"
  );
}

const AppSettings = {
  GRAPHQL_SERVER: getServiceUri(getBaseUrl(), GraphQLServices.Trainer),
  RB_ERROR: "RB_ERROR",
  DefaultLanguages: [
    {
      code: LanguageCodes.English,
      title: "English",
      direction: "ltr",
      abbreviation: "English",
    },
    {
      code: LanguageCodes.Persian,
      title: "فارسی",
      direction: "rtl",
      abbreviation: "فارسی",
    },
    {
      code: LanguageCodes.Arabic,
      title: "العربية",
      direction: "rtl",
      abbreviation: "العربية",
    },
  ] as Language[],
  ShowNavMenu: false,
  Paths: {
    ScreenshotsFilesPath: "/assets/{0}/screenshots",
    ScreenshotsCommonFilesPath: "/assets/common/screenshots",
    TutorialVideosFilesPath: "/assets/{0}/tutorial-videos",
    TutorialVideosCommonFilesPath: "/assets/common/tutorial-videos",
  },
  AppName: "trainer-webapp-client",
  ConfigProviderApi: getServiceUri(
    getBaseUrl(),
    GraphQLServices.ConfigProvider
  ),
  SlidesAutoPlayDelay: 5000,
  SubItemsShowDelay: 200,
  Links: {
    FAQ: "https://www.rambody.com/faq",
    Blog: {
      [LanguageCodes.English]: "https://www.rambody.com/blog",
      [LanguageCodes.Persian]: "https://instagram.com/rambody.fa",
      [LanguageCodes.Arabic]: "https://www.rambody.com/ar/blog",
      [LanguageCodes.Turkish]: "https://www.rambody.com/tr/blog",
      [LanguageCodes.Spanish]: "https://www.rambody.com/es/blog",
      [LanguageCodes.French]: "https://www.rambody.com/fr/blog",
      [LanguageCodes.Portuguese]: "https://www.rambody.com/blog",
      [LanguageCodes.Darija]: "https://www.rambody.com/ar/blog",
      [LanguageCodes.Vietnamese]: "https://www.rambody.com/vi/blog", // Add Vietnamese blog URL
    },
    Email: "info@rambody.com",
    SupportEmail: "support@rambody.com",
    Website: "https://www.rambody.com/",
    // Athlete app links
    GooglePlayStoreLink:
      "https://play.google.com/store/apps/details?id=co.rambody",
    AppStoreLink: "https://apps.apple.com/app/rambody/id1300350064",
    // Trainer app links
    TrainerGooglePlayStoreLink:
      "https://play.google.com/store/apps/details?id=co.trainer_rambody",
    TrainerAppStoreLink:
      "https://apps.apple.com/app/rambody-trainer/id1439710343",
    AndroidDirectDownloadLink:
      "https://trainer.rambody.com:1343/ftp/pub/app/rambody.apk",
    OpenAppLink: "rambody://trainer_profile/{0}/",
    OpenPackageAppLink: "rambody://package/{0}/",
  },
};
export default AppSettings;
